/** @format */

import React, { useState } from "react";
import "./qualification.css";
import { HiOutlineAcademicCap, HiOutlineBriefcase } from "react-icons/hi";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button button--flex qualification__active"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}>
            <HiOutlineAcademicCap className="qualification__icon" />
            Education
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification__button button--flex qualification__active"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}>
            <HiOutlineBriefcase className="qualification__icon" />
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"
            }>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">HTML/CSS</h3>
                <span className="qualification__subtitle">NIIT</span>
                <div className="qualification__calendar">2017</div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">+2</h3>
                <span className="qualification__subtitle">NIST College</span>
                <div className="qualification__calendar">2018-2021</div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">BSc. CSIT</h3>
                <span className="qualification__subtitle">Tribhwan University</span>
                <div className="qualification__calendar">2021-2022</div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
          <div
            className={
              toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"
            }>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Prime College</h3>
                <span className="qualification__subtitle">UI/UX and Flutter Intern</span>
                <div className="qualification__calendar">2022-2023</div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Junior Flutter Developer</h3>
                <span className="qualification__subtitle">Premium Technologies</span>
                <div className="qualification__calendar">2023</div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">UIUX-Flutter-React</h3>
                <span className="qualification__subtitle">Freelancing</span>
                <div className="qualification__calendar">2023-Present</div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
